// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list_menu":"list_menu-2FmK-xq0","morehNew":"morehNew-1oM6PO6u","more":"more-1avFhijg"};